import { DataContracts } from "../../../../contracts";
import { eBranches } from "sb-helpers";
// No unit test because it's well covered with integration tests
export function isNotLiveRacingEvent(item) {
    if (item.PickedEvent
        && item.PickedEvent.event
        && isRacingEvent(item.PickedEvent.event.sportID)
        && isLiveOrFinished(item.PickedEvent.event.status)) {
        return false;
    }
    return true;
}
function isRacingEvent(sportId) {
    return sportId === eBranches.HorseRacing.toString()
        || sportId === eBranches.GreyHoundsRacing.toString();
}
function isLiveOrFinished(status) {
    return status === DataContracts.GameStatus.RaceOff
        || status === DataContracts.GameStatus.Resulted;
}
//# sourceMappingURL=isNotLiveRacingEvent.js.map